(function () {
    if (window.EEGCartUtils) return;

    const getSectionInnerHtml = (html, selector) => {
        if (!html || !selector) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const element = doc.querySelector(selector);
        return element ? element.innerHTML : '';
    };

    const updateCartIconBubble = (sections) => {
        if (!sections || !sections['eeg-cart-icon-bubble']) return;
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (!cartIcon) return;
        const nextHtml = getSectionInnerHtml(sections['eeg-cart-icon-bubble'], '.shopify-section');
        if (!nextHtml) return;
        cartIcon.innerHTML = nextHtml;
    };

    const updateCartLiveRegion = (sections) => {
        if (!sections || !sections['eeg-cart-live-region-text']) return;
        const nextText = getSectionInnerHtml(sections['eeg-cart-live-region-text'], '.shopify-section');
        if (!nextText) return;
        const liveRegions = document.querySelectorAll('#cart-live-region-text, #CartDrawer-LiveRegionText');
        if (!liveRegions.length) return;
        liveRegions.forEach((liveRegion) => {
            liveRegion.textContent = nextText.trim();
            liveRegion.setAttribute('aria-hidden', 'false');
            window.setTimeout(() => {
                liveRegion.setAttribute('aria-hidden', 'true');
            }, 1000);
        });
    };

    window.EEGCartUtils = {
        getSectionInnerHtml,
        updateCartIconBubble,
        updateCartLiveRegion,
    };
})();
